module.exports = "<p>\r\n  Loading, Please wait...\r\n</p>\r\n"